/**
 * Fellido · Mengenstaffel
 *
 * WICHTIG: Diese Section rechnet keinen Rabatt aus, sie zeigt ihn nur an.
 * Den Preis macht Shopify ueber einen automatischen Mengenrabatt. Sonst
 * stuende im Warenkorb ein anderer Betrag als auf der Seite.
 *
 * Aufgabe hier: die gewaehlte Menge in Horizons Produktformular schreiben,
 * damit der echte Warenkorb-Button sie uebernimmt. Zusaetzlich kann die
 * Section einen eigenen Warenkorb-Button haben — sie liegt oft weit unter
 * dem Kaufbereich, und ohne Button waehlt man dort eine Menge ins Leere.
 */
class FBundle extends HTMLElement {
  connectedCallback() {
    this.karten = [...this.querySelectorAll('[data-f-bundle-tier]')];
    this.karten.forEach((k) => k.addEventListener('click', () => this.waehle(k)));

    const vorgewaehlt = this.karten.find((k) => k.dataset.default === 'true') || this.karten[0];
    if (vorgewaehlt) this.waehle(vorgewaehlt, true);

    this.knopf = this.querySelector('[data-f-bundle-add]');
    this.knopf?.addEventListener('click', () => this.legeInDenWarenkorb());
  }

  /**
   * Legt die gewaehlte Menge direkt in den Warenkorb. Der Rabatt kommt
   * weiterhin von Shopifys automatischem Mengenrabatt — hier wird nichts
   * gerechnet, nur die Menge uebergeben.
   */
  async legeInDenWarenkorb() {
    const variante = this.dataset.variant;
    if (!variante || !this.knopf || this.laeuft) return;

    const karte = this.karten.find((k) => k.dataset.state === 'gewaehlt') || this.karten[0];
    const menge = Number(karte?.dataset.qty || 1);

    const label = this.querySelector('[data-f-bundle-label]');
    const vorher = label?.textContent;
    this.laeuft = true;
    this.knopf.disabled = true;
    if (label && this.dataset.btnBusy) label.textContent = this.dataset.btnBusy;

    try {
      const antwort = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variante), quantity: menge }] }),
      });
      if (!antwort.ok) throw new Error(await antwort.text());
      // Dasselbe Signal wie der normale Kaufbutton: Drawer aktualisiert und oeffnet.
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
    } catch (e) {
      console.error('Fellido Mengenstaffel: Hinzufuegen fehlgeschlagen', e);
      // Ehrlicher Rueckfall statt stiller Fehler.
      window.location.href = '/cart';
    } finally {
      this.laeuft = false;
      this.knopf.disabled = false;
      if (label && vorher) label.textContent = vorher;
    }
  }

  mengenFeld() {
    return document.querySelector('form[action*="/cart/add"] input[name="quantity"]');
  }

  waehle(karte, still = false) {
    this.karten.forEach((k) => {
      const aktiv = k === karte;
      k.setAttribute('aria-checked', String(aktiv));
      k.dataset.state = aktiv ? 'gewaehlt' : 'offen';
    });

    const menge = Number(karte.dataset.qty || 1);
    const feld = this.mengenFeld();
    if (feld) {
      feld.value = String(menge);
      // Horizon haengt an change/input — beides melden, sonst bleibt die
      // Anzeige am Button auf der alten Zahl stehen.
      feld.dispatchEvent(new Event('input', { bubbles: true }));
      feld.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (!still) {
      this.dispatchEvent(new CustomEvent('f-bundle:change', { detail: { menge }, bubbles: true }));
    }
  }
}

if (!customElements.get('f-bundle')) customElements.define('f-bundle', FBundle);
